var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5234 6.5H8.03906L7.6875 4.78125C7.60938 4.35156 7.21875 4 6.78906 4H3.46875C3.19531 4 3 4.23438 3 4.46875V4.78125C3 5.05469 3.19531 5.25 3.46875 5.25H6.51562L9.25 19.8203C8.85938 20.2891 8.625 20.875 8.625 21.5C8.625 22.9062 9.71875 24 11.125 24C12.4922 24 13.625 22.9062 13.625 21.5C13.625 21.0703 13.4688 20.6406 13.2734 20.25H18.9375C18.7422 20.6406 18.625 21.0703 18.625 21.5C18.625 22.9062 19.7188 24 21.125 24C22.4922 24 23.625 22.9062 23.625 21.5C23.625 20.8359 23.3125 20.1719 22.8438 19.7422C22.7656 19.3125 22.375 19 21.9453 19H10.3828L9.91406 16.5H22.8438C23.3125 16.5 23.6641 16.2266 23.7812 15.7578L25.4609 7.63281C25.5781 7.04688 25.1484 6.5 24.5234 6.5ZM12.375 21.5C12.375 22.2031 11.7891 22.75 11.125 22.75C10.4219 22.75 9.875 22.2031 9.875 21.5C9.875 20.8359 10.4219 20.25 11.125 20.25C11.7891 20.25 12.375 20.8359 12.375 21.5ZM21.125 22.75C20.4219 22.75 19.875 22.2031 19.875 21.5C19.875 20.8359 20.4219 20.25 21.125 20.25C21.7891 20.25 22.375 20.8359 22.375 21.5C22.375 22.2031 21.7891 22.75 21.125 22.75ZM22.6094 15.25H9.67969L8.27344 7.75H24.1719L22.6094 15.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopCart);
export default __webpack_public_path__ + "static/media/shopCart.90e58daaad3573b5116322f244848150.svg";
export { ForwardRef as ReactComponent };